import React from "react";

const RefrigeratedTruckHero = () => {
  return (
    <section className="py-5">
      <div className="container-fluid container-lg py-5">
        <div className="row">
         <div className="col-12 px-md-0 px-lg-5 text-center">

  {/* Heading */}
  <h1 
    data-aos="fade-up"
    className="fw-normal py-2"
  >
    Affordable Refrigerated Truck Rental in Dubai & Abu Dhabi for Bulk Transport – Book Today
  </h1>

  {/* Paragraph */}
  <p 
    data-aos="fade-up" 
    data-aos-delay="150"
    className="mt-3"
  >
    Looking for a reliable refrigerated truck rental in Dubai or Abu Dhabi? We provide 
    <strong> 5-ton, 7-ton, and 10-ton refrigerated trucks</strong> designed for bulk and mixed cargo 
    transport with precise temperature control. Ideal for <strong>food distribution, dairy, catering, 
    and pharmaceutical logistics</strong>, our fleet ensures safe and hygienic cold chain delivery 
    with advanced cooling systems and tail-lift support for smooth loading and unloading.
  </p>

  {/* Supporting Line */}
  <p
    data-aos="fade-up"
    data-aos-delay="250"
    className="mt-2"
  >
    Book today for dependable, temperature-controlled transport across Dubai, Abu Dhabi, and the UAE.
  </p>

  {/* CTA */}
  <strong 
    data-aos="zoom-in" 
    data-aos-delay="350"
    className="d-block mt-3"
  >
    Call or WhatsApp now to hire a refrigerated truck for secure bulk transport.
  </strong>

</div>
        </div>
      </div>
    </section>
  );
};

export default RefrigeratedTruckHero;